import { createSlice, CreateSliceOptions, SliceCaseReducers } from '@reduxjs/toolkit';
import { logoutThunk } from 'features/auth/thunks/logoutThunk';
import { GLOBAL_PRESERVE_KEYS, preserveStateKeys, resetStore } from 'utils/rtkSliceUtils';

// creates a slice with state reset extra reducers installed
// use this at all place instead of createSlice
export const createSliceWithStateReset = <State, CR extends SliceCaseReducers<State>>(options: {
  name: CreateSliceOptions<State, CR>['name'];
  initialState: CreateSliceOptions<State, CR>['initialState']; // initialState can be either an object or a function
  reducers: CreateSliceOptions<State, CR>['reducers'];
  preserveKeys?: string[]; // Allow preserving specific keys
  extraReducers?: CreateSliceOptions<State, CR>['extraReducers'];
}) =>
  createSlice({
    name: options.name,
    initialState: options.initialState,
    reducers: options.reducers,
    extraReducers: (builder) => {
      builder.addCase(logoutThunk.fulfilled, (state) => {
        // Use default PRESERVE_KEYS if no specific keys are provided
        const keysToPreserve: string[] = options.preserveKeys || GLOBAL_PRESERVE_KEYS;
        const preservedState = preserveStateKeys(state, keysToPreserve);
        const { initialState } = options;
        const resetStoreResult = resetStore(state, initialState, preservedState, keysToPreserve);
        return resetStoreResult as State;
      });
      // Apply custom extra reducers (if provided any)
      if (options.extraReducers) {
        options.extraReducers(builder);
      }
    },
  });
